import { Modal, Text, Group, Button } from '@mantine/core';
import { useIntl } from 'react-intl';

interface ConfirmActionModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

export const ConfirmActionModal = ({
  opened,
  onClose,
  onConfirm,
  title,
  message,
}: ConfirmActionModalProps) => {
  const intl = useIntl();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Text mb="lg">{message}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button color="red" onClick={handleConfirm}>
          {intl.formatMessage({ id: 'confirm' })}
        </Button>
      </Group>
    </Modal>
  );
};
